export default "__VITE_ASSET__B$kO$CJS__"